import http from "utils/http";
import { AUTH, CORE } from "config/http"; // eslint-disable-line

/**
 * Naming guide style
 *
 * CRUD
 *
 * GET    load[EntityName][action]...
 * POST   create...
 * PUT    replace...
 * PATCH  update...
 * DELETE delete...
 *
 * Custom actions
 *
 * POST /Customers/${id}/sendVerificationCode
 * customersSendVerificationCode
 *
 * POST /Customers/reset-password
 * customersResetPassword
 *
 * POST /Customers/${id}/phoneVerification
 * customersPhoneVerification
 *
 */

export const login = (code) => {
  return http.get(`${CORE}/user/login?code=${code}`);
};

export const loadMe = (id) => {
  return http.get(`${CORE}/users/${id}`);
};

export const sendInvest = (data) => {
  return http.post(`${CORE}/invests`, data);
};

export const sendWithdraw = (data) => {
  return http.post(`${CORE}/withdrawal`, data);
};

export const modifyInvest = (data) => {
  return http.put(`${CORE}/invests`, data);
};

export const deleteInvest = () => {
  return http.delete(`${CORE}/invests`);
};

export const cancelWithdraw = () => {
  return http.delete(`${CORE}/withdrawal`);
};

export const getNotification = () => {
  return http.get(`${CORE}/notifications`);
};

export const getDashboard = () => {
  return http.get(`${CORE}/dashboard`);
};

export const getTickers = () => {
  return http.get(`${CORE}/tickers?start_date=2018-11-20`);
};

export const getTransactions = () => {
  return http.get(`${CORE}/transactions`);
};

export const setMarketingEmailConsentInSettings = (boolVal) => {
  return http.patch(`${CORE}/settings`, { consent: boolVal });
};



// WEBPACK FOOTER //
// ./src/utils/webAPI.js